exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--commentCut__276H0{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%;padding-top:16px}.styles--date__3MQ77{color:#b3c2da;font-size:12px;font-weight:400;margin-left:8px;-webkit-box-flex:2;-ms-flex-positive:2;flex-grow:2;float:left}.styles--avatarItem__1Eb4y{display:-webkit-box;display:-ms-flexbox;display:flex;width:29px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.styles--avatar__1L4y6{width:21px;height:21px;min-width:21px;background:url(\"/public/images/_anti/panel/student-default.svg\");border-radius:50%;margin-right:10px;background-size:21px;display:inline-block}.styles--fullname__2XyNw{font-size:13px;font-weight:700;display:inline-block;vertical-align:top;text-decoration:none}.styles--cut__3-B7I{font-size:13px;font-weight:600;cursor:pointer}.styles--dateWrapper__m3r82{-webkit-box-flex:2;-ms-flex-positive:2;flex-grow:2}\n", ""]);

// exports
exports.locals = {
	"commentCut": "styles--commentCut__276H0",
	"date": "styles--date__3MQ77",
	"avatarItem": "styles--avatarItem__1Eb4y",
	"avatar": "styles--avatar__1L4y6",
	"fullname": "styles--fullname__2XyNw",
	"cut": "styles--cut__3-B7I",
	"dateWrapper": "styles--dateWrapper__m3r82"
};